// extracted by mini-css-extract-plugin
export var dropdownButton = "_40-0";
export var fullWidthDropdownButton = "_40-1";
export var icon = "_40-3";
export var iconPlaceholder = "_40-2";
export var menuItemRow = "_40-8";
export var separator = "_40-c";
export var shortcutContainer = "_40-7";
export var shortcutIconLg = "_40-6";
export var shortcutIconMd = "_40-5";
export var shortcutIconSm = "_40-4";
export var submenuChevron = "_40-b";
export var submenuDropdown = "_40-9";
export var submenuTriggerRow = "_40-a";